export const getFileExtension = (fileName) => {
  if (!fileName) return ""
  const fileExtensionRegex = new RegExp("\\.\\w+$");
  const [fileExtension] = fileName.match(fileExtensionRegex);
  return fileExtension.slice(1);
};